import {Container as StyledContainer} from './styles';
import {ContainerProps} from './types';

const Container: React.FC<ContainerProps> = (props) => (
  <StyledContainer {...props} />
);

export default Container;
